import React, { useCallback, useEffect, useState } from "react";
import Lottie from "lottie-react";
import favAnimation from "../../../public/assets/lottie/AddOrRemoveFavourite.json";

export function useFavoriteToggleDialog(autoCloseMs = 2500) {
  const [showDialog, setShowDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");

  const showFavoriteDialog = useCallback((isFavorite) => {
    setDialogMessage(
      isFavorite ? "تمت الإضافة للمفضلة " : "تم الحذف من المفضلة "
    );
    setShowDialog(true);
  }, []);

  useEffect(() => {
    if (!showDialog) return undefined;

    const timeoutId = window.setTimeout(() => {
      setShowDialog(false);
    }, autoCloseMs);

    return () => window.clearTimeout(timeoutId);
  }, [showDialog, autoCloseMs]);

  return {
    showDialog,
    dialogMessage,
    showFavoriteDialog,
    closeFavoriteDialog: () => setShowDialog(false),
  };
}

export default function FavoriteToggleDialog({ open, message }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="w-[260px] rounded-[8px] bg-white p-6 text-center shadow-xl animate-scaleIn">
        <Lottie
          animationData={favAnimation}
          loop={false}
          className="mx-auto h-32 w-32"
        />

        <p className="mt-3 font-[cairo] text-sm font-semibold text-gray-800">
          {message}
        </p>
      </div>
    </div>
  );
}
